import { render, staticRenderFns } from "./LeadList.vue?vue&type=template&id=121aeb12&scoped=true"
import script from "./LeadList.vue?vue&type=script&lang=js"
export * from "./LeadList.vue?vue&type=script&lang=js"
import style0 from "./LeadList.vue?vue&type=style&index=0&id=121aeb12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121aeb12",
  null
  
)

export default component.exports